import * as Yup from 'yup';

export const updateDescriptionSchema = Yup.object({
	formValue: Yup.string()
		.trim()
		.min(25, 'Description must be at least 25 characters')
		.max(255, 'Description must be maximum 255 characters')
		.required('Required'),
});
